import Service from "../../Service";
const resource = "HmnReportAriStart/";

export default {
    list(parameters, requestID) {
        return Service.post(resource + "list", parameters, {
            params: { requestID: requestID },
        });
    },
};